// src/components/dashboard/Filter.jsx
import React, { useState } from "react";
import { CalendarDays, Pencil, Check, X } from "lucide-react";

const Filter = ({value, onChange }) => {
  const [activeTab, setActiveTab] = useState(value);
  const [editing, setEditing] = useState(false);
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [tempRange, setTempRange] = useState({ from: "", to: "" });

  const tabs = ["Today", "Yesterday", "Weekly", "Monthly","All Time", "Custom Date"];

  const handleClick = (tab) => {
    if (tab === "Custom Date") {
      // Toggle only when Custom Date clicked
      if (activeTab === "Custom Date") {
        setActiveTab(""); // Close it
        setEditing(false);
      } else {
        setActiveTab("Custom Date");
        setEditing(true); // Open it
      }
    } else {
      setActiveTab(tab);
      setEditing(false);
      onChange?.(tab);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setTempRange({ ...tempRange, [name]: value });
  };

  const handleApply = () => {
    if (tempRange.from && tempRange.to && tempRange.from <= tempRange.to) {
      setDateRange(tempRange);
      setEditing(false);
      setActiveTab("Custom Date");
      onChange?.({ type: "Custom Date", ...tempRange });
    }
  };

  const handleCancel = () => {
    setEditing(false);
    setTempRange(dateRange);
  };

  return (
    <div className="w-full space-y-3">
      {/* Tabs */}
      <div className="flex items-center gap-5 text-[14px] font-medium select-none overflow-auto no-scrollbar">
        {tabs.map((tab) => {
          const isActive = activeTab === tab;
          return (
            <button
              key={tab}
              onClick={() => handleClick(tab)}
              className={`relative pb-1  tracking-wide transition-all duration-300 text-nowrap  ${isActive ? "text-gray-950 font-bold text-base" : "text-sm text-gray-400 hover:text-gray-700"
                }`}
            >
              {tab}
              <span
                className={`absolute left-0 -bottom-[2px] h-[2px] rounded-full transition-all duration-300 ${isActive ? "w-full bg-gray-900" : "w-0 bg-transparent"
                  }`}
              />
            </button>
          );
        })}
      </div>

      {/* Custom date picker */}
      {activeTab === "Custom Date" && (
        <div className="p-2 bg-transparent rounded border border-dashed border-gray-200">
          {!editing ? (
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-700">
                From: <b>{dateRange.from || "--"}</b> | To: <b>{dateRange.to || "--"}</b>
              </span>
              <button
                onClick={() => setEditing(true)}
                className="text-blue-600 flex items-center gap-1 hover:underline"
              >
                <Pencil size={14} /> Edit
              </button>
            </div>
          ) : (
            <div className="flex flex-col gap-4 text-sm">
              <div className="flex gap-2 md:gap-4">
                <div className="flex flex-col gap-1 w-full">
                  <label className="text-gray-600 font-semibold">Start Date:</label>
                  <input
                    type="date"
                    name="from"
                    value={tempRange.from}
                    onChange={handleChange}
                    className="border rounded p-1 focus:ring focus:ring-gray-200 outline-none"
                  />
                </div>

                <div className="flex flex-col gap-1 w-full">
                  <label className="text-gray-600 font-semibold">End Date:</label>
                  <input
                    type="date"
                    name="to"
                    value={tempRange.to}
                    onChange={handleChange}
                    className="border rounded p-1 focus:ring focus:ring-gray-200 outline-none"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-2">
                <button
                  onClick={handleCancel}
                  className="px-4 py-1 text-xs rounded-lg border flex items-center gap-1 hover:bg-gray-50"
                >
                  <X size={14} /> Cancel
                </button>
                <button
                  onClick={handleApply}
                  disabled={!tempRange.from || !tempRange.to || tempRange.from > tempRange.to}
                  className="px-4 py-1 text-xs bg-gray-900 text-white rounded-lg flex items-center gap-1 hover:bg-gray-800 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <Check size={14} /> Apply
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Filter;